module.exports = __webpack_public_path__ + "img/shipin1.a6765619.png";